    // --- Filter buttons ---

    if (document.querySelector('#product-filters')) {
      document.addEventListener('click', function (e) {
        if (e.target.id == 'open-filters' || e.target.parentNode.id == 'open-filters') {
          document.querySelector('#product-filters').classList.add('is-open');
          // document.querySelector('header.fusion-header-wrapper').style.position = 'unset';
          // document.querySelector('.fusion-is-sticky .fusion-header-v3 .fusion-header').style.position = 'unset';
        } else if (e.target.id == 'close-filters' || e.target.parentNode.id == 'close-filters') {
          document.querySelector('#product-filters').classList.remove('is-open');
          // document.querySelector('header.fusion-header-wrapper').position = 'relative';
          // document.querySelector('.fusion-is-sticky .fusion-header-v3 .fusion-header').style.position = 'fixed';
        }
      });
    }
